import { httpsCallable } from "firebase/functions";
import { functions } from "../firebase"; // ✅ import from your firebase.js

export async function callAPI(userMessage) {
    const threadId = localStorage.getItem("threadId");
    const callOpenAI = httpsCallable(functions, "callOpenAI");

    // Only include threadId if it exists
    const payload = threadId ? { userMessage, threadId } : { userMessage };
    // console.log("Sending payload to callable function:", payload);
    const result = await callOpenAI(payload);
    // console.log("Result from callable function:", result);
    const { response, threadId: newThreadId } = result.data;

    if (!threadId) {
        localStorage.setItem("threadId", newThreadId);
    }

    return response;
}